import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Mic, Mic2, Users, Trophy, Zap, Music, ArrowRight, X } from 'lucide-react';
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { submitCyphaKingsRegistration, submitFuoriCashNewsletter } from '../services/api';

// Mini player YouTube per le reaction dei video FreestyleMania
const FreestyleManiaVideos = () => {
  const [activeReaction, setActiveReaction] = useState(null);

  const videos = [
    { n: 1, main: '2ktNOZOHb6g', reactionId: 'lT52-VIcjDo' },
    { n: 2, main: 'BFoeqrnmQaM', reactionId: 'm24rixCPc8A' },
    { n: 3, main: 'xWIkdLYLmY4', reactionId: '5fZc2oA1Cbg' },
  ];

  return (
    <div className="mt-8">
      <h4
        className="text-2xl font-bold text-red-400 text-center mb-6"
        style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}
      >
        GUARDA TUTTE LE PARTI
      </h4>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {videos.map((v) => (
          <div
            key={v.n}
            className="rounded-lg overflow-hidden border border-gray-700"
            style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
          >
            <div className="px-3 py-2 border-b border-gray-700">
              <h5 className="text-sm font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>
                PARTE {v.n}
              </h5>
            </div>
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <iframe
                src={`https://www.youtube.com/embed/${v.main}`}
                title={`FreestyleMania - Parte ${v.n}`}
                data-testid={`freestylemania-video-${v.n}`}
                className="absolute top-0 left-0 w-full h-full"
                style={{ border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
            <div className="flex flex-col items-center justify-center gap-2 px-3 py-3 border-t border-gray-700">
              <span
                className="text-gray-300 text-xs text-center leading-tight"
                style={{ fontFamily: 'Oswald, sans-serif' }}
              >
                Guarda la reaction del divanetto
              </span>
              <button
                type="button"
                onClick={() => setActiveReaction({ id: v.reactionId, n: v.n })}
                data-testid={`freestylemania-reaction-${v.n}`}
                aria-label={`Apri mini player reaction - Parte ${v.n}`}
                title="Guarda la reaction del divanetto"
                className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[var(--tp-red)] hover:bg-[var(--tp-red-light)] text-white shadow-lg transition-colors cursor-pointer"
              >
                <Mic2 size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Mini Player Overlay (Portal su body per evitare transform del Dialog padre) */}
      {activeReaction && createPortal(
        <div
          role="dialog"
          aria-modal="true"
          aria-label={`Reaction del divanetto - Parte ${activeReaction.n}`}
          data-testid="reaction-miniplayer"
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(8px)' }}
          onClick={() => setActiveReaction(null)}
        >
          <div
            className="relative w-full max-w-3xl rounded-lg overflow-hidden border border-gray-700 shadow-2xl"
            style={{ backgroundColor: '#0a0a0a' }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-700">
              <div className="flex items-center gap-2">
                <Mic2 size={18} className="text-[var(--tp-red)]" />
                <h6
                  className="text-sm sm:text-base font-bold text-white"
                  style={{ fontFamily: 'Oswald, sans-serif' }}
                >
                  REACTION DEL DIVANETTO — PARTE {activeReaction.n}
                </h6>
              </div>
              <button
                type="button"
                onClick={() => setActiveReaction(null)}
                data-testid="reaction-miniplayer-close"
                aria-label="Chiudi mini player"
                className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-gray-800 hover:bg-gray-700 text-white transition-colors"
              >
                <X size={18} />
              </button>
            </div>

            {/* Video */}
            <div className="relative w-full bg-black" style={{ paddingBottom: '56.25%' }}>
              <iframe
                src={`https://www.youtube.com/embed/${activeReaction.id}?autoplay=1&rel=0`}
                title={`Reaction del divanetto - Parte ${activeReaction.n}`}
                data-testid="reaction-miniplayer-iframe"
                className="absolute top-0 left-0 w-full h-full"
                style={{ border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

const formats = [
  {
    id: 1,
    order: 7,
    title: "3 MC'S & 1 DEEJAY",
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/j68d7pe4_3mc%261dj-logo.avif",
    icon: Users,
    shortDesc: "Uno show sempre imprevedibile e mai uguale con i migliori rappers e freestylers italiani",
    fullContent: (
      <>
        <h3 className="text-2xl font-bold mb-4 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>3 MC's & 1 DEEJAY</h3>
        <p className="text-gray-300 mb-4 leading-relaxed">
          Uno show sempre imprevedibile e mai uguale, le migliori "Combo" con i migliori rappers e freestylers Italiani.
        </p>
        <p className="text-gray-300 mb-4 leading-relaxed">
          Info: <a href="mailto:book@masnetwork.it" className="text-red-400 hover:underline font-bold">book@masnetwork.it</a>
        </p>
      </>
    ),
    hasForm: true,
    formType: '3mc-info'
  },
  {
    id: 2,
    order: 1,
    title: "CYPHA KINGS",
    image: "https://static.wixstatic.com/media/e93d0f_7127cfcadfd044c0a6290f277635dd2a~mv2.jpg/v1/fill/w_4270,h_1098,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/e93d0f_7127cfcadfd044c0a6290f277635dd2a~mv2.jpg",
    teaserVideoId: "aqtHKX5CwzA",
    icon: null,
    shortDesc: "Il Cerchio nella JAM e ON AIR su RADIO DEE JAY da SAYWAAD",
    fullContent: null,
    hasForm: true,
    formType: 'cypha-kings'
  },
  {
    id: 3,
    order: 5,
    title: "FUORI PER IL CASH",
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/ubuk1l1b_fuori%20per%20il%20cash%20logo.png",
    teaserVideoId: "paZDDqd8Qx8",
    icon: Trophy,
    shortDesc: "Battle ad eliminazione - Allenamento senza pressione",
    fullContent: null,
    hasForm: true,
    formType: 'fuori-cash'
  },
  {
    id: 4,
    order: 6,
    title: "X5K FREESTYLE BATTLE",
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/y3gkpnb0_Progetto%20senza%20titolo%20%287%29.jpg",
    teaserVideoId: "DxKNlhjZH1U",
    icon: Trophy,
    shortDesc: "La battle di Tedua & Mastafive che unisce improvvisazione e testi scritti",
    fullContent: (
      <>
        <h3 className="text-2xl font-bold mb-4 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>TEDUA & MASTAFIVE'S X5K - FREESTYLE BATTLE</h3>
        <p className="text-gray-300 mb-4 leading-relaxed">
          La <strong className="text-white">x5K Freestyle Battle</strong> (letto "Per Cinque Kappa") è una competizione di rap e freestyle nata da un'idea dei rapper e produttori italiani <strong className="text-white">Tedua</strong> e <strong className="text-white">Mastafive</strong>.
        </p>
        <p className="text-gray-300 mb-4 leading-relaxed">
          L'evento è nato con l'obiettivo di portare il rap e le "barre" di altissimo livello in contesti importanti. La sua primissima edizione, battezzata <strong className="text-red-400">Tana Del Granchio Edition</strong>, si è svolta infatti a febbraio 2025 durante la settimana del <strong className="text-white">Festival di Sanremo</strong> (come evento del "Fuori Festival" presso il Lido Blue Bay).
        </p>
        
        <h4 className="text-xl font-bold mt-6 mb-3 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>Ecco i dettagli principali:</h4>
        
        <h5 className="text-lg font-bold mt-4 mb-2 text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>Il format innovativo:</h5>
        <p className="text-gray-300 mb-4 leading-relaxed">
          A differenza delle classiche battle incentrate esclusivamente sull'improvvisazione pura, la <strong className="text-white">x5K</strong> prevede sfide che <strong className="text-red-400">uniscono l'improvvisazione in rima a sfide su veri e propri testi rap scritti</strong>. Questo mette alla prova gli artisti in modo più completo.
        </p>
        
        <h5 className="text-lg font-bold mt-4 mb-2 text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>La conduzione (Host):</h5>
        <p className="text-gray-300 mb-4 leading-relaxed">
          La conduzione dell'evento è affidata direttamente ai suoi ideatori, ovvero <strong className="text-white">Tedua</strong> e <strong className="text-white">Mastafive</strong>, accompagnati ai piatti dalla leggenda dell'hip hop italiano <strong className="text-red-400">DJ Double S</strong>.
        </p>
        
        <h5 className="text-lg font-bold mt-4 mb-2 text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>Una giuria d'eccezione:</h5>
        <p className="text-gray-300 mb-4 leading-relaxed">
          Per giudicare la primissima edizione sono stati scelti tre pesi massimi della storia del freestyle italiano: <strong className="text-white">Ensi</strong>, <strong className="text-white">Rayden</strong> e <strong className="text-white">Moreno</strong>.
        </p>
        
        <h5 className="text-lg font-bold mt-4 mb-2 text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>I partecipanti:</h5>
        <p className="text-gray-300 leading-relaxed">
          La prima edizione ha visto sfidarsi <strong className="text-red-400">8 tra i migliori MCs e freestyler</strong> del panorama italiano: <strong className="text-white">Morbo</strong>, <strong className="text-white">BLNKAY</strong>, <strong className="text-white">Giuss Dawg</strong>, <strong className="text-white">Drimer</strong>, <strong className="text-white">True Skill</strong>, <strong className="text-white">Cuta</strong>, <strong className="text-white">Shekkero</strong> e <strong className="text-white">Higher</strong>.
        </p>

        {/* Playlist YouTube X5K */}
        <h4 className="text-xl font-bold mt-8 mb-4 text-red-400 text-center" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          GUARDA LA PLAYLIST
        </h4>
        <div className="rounded-lg overflow-hidden border border-gray-700" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.youtube.com/embed/DxKNlhjZH1U?list=PLw3BVEFbgSg7xHRAql-agVyvqdOxS_PSM"
              title="X5K Freestyle Battle - Playlist"
              data-testid="x5k-playlist"
              className="absolute top-0 left-0 w-full h-full"
              style={{ border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>

      </>
    )
  },
  {
    id: 5,
    order: 2,
    title: "CYPHER KILLA",
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/u3vrmvho_CypherKilla_Negative.pdf.png",
    teaserVideoId: "aXvPZQFIre8",
    icon: Mic,
    shortDesc: "La battle di Emis Killa in collaborazione con Tecniche Perfette",
    fullContent: (
      <>
        <h3 className="text-2xl font-bold mb-4 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>CYPHER KILLA</h3>
        <p className="text-gray-300 mb-4 leading-relaxed">
          <strong className="text-white">Cypher Killa</strong> è la battle di <strong className="text-white">Emis Killa</strong> realizzata in collaborazione con <strong className="text-red-400">Tecniche Perfette</strong> che si svolge all'interno del suo evento <strong className="text-white">EM16</strong>.
        </p>
        <p className="text-gray-300 mb-4 leading-relaxed">
          Clicca sull'icona qui sotto per seguire il profilo ufficiale:
        </p>
        <div className="flex justify-center mb-6">
          <a 
            href="https://www.instagram.com/emis.sedici/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-purple-600 via-pink-600 to-orange-600 hover:scale-110 transition-transform duration-300"
            aria-label="Segui Emis Sedici su Instagram"
          >
            <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
          </a>
        </div>

        {/* Playlist YouTube Cypher Killa */}
        <h4 className="text-xl font-bold mb-4 text-red-400 text-center" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          GUARDA LA PLAYLIST
        </h4>
        <div className="rounded-lg overflow-hidden border border-gray-700" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.youtube.com/embed/aXvPZQFIre8?list=PLw3BVEFbgSg7r_8Iw-MhJaGDLBiewgCrW"
              title="Cypher Killa - Playlist"
              data-testid="cypher-killa-playlist"
              className="absolute top-0 left-0 w-full h-full"
              style={{ border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
      </>
    )
  },
  {
    id: 10,
    order: 9,
    title: "FREESTYLE REACTION",
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/pnjk84z8_freestyle%20reaction.png",
    teaserVideoId: "QAGBIPqLyV0",
    icon: Mic,
    shortDesc: "Il format di Rend tra challenge di freestyle e talk/intervista dietro le quinte",
    fullContent: (
      <>
        <h3 className="text-2xl font-bold mb-4 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>FREESTYLE REACTION</h3>
        <p className="text-gray-300 mb-4 leading-relaxed">
          <strong className="text-white">Freestyle Reaction</strong> ideato e condotto da <strong className="text-red-400">Rend</strong>.
        </p>
        <p className="text-gray-300 mb-6 leading-relaxed">
          Il programma è un vero e proprio <strong className="text-white">"salotto"</strong> dedicato alla cultura del freestyle italiano e si divide in due macro-sezioni, unendo l'intrattenimento performativo puro all'approfondimento giornalistico e personale degli MC.
        </p>

        <h4 className="text-xl font-bold mt-6 mb-3 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>1. La Freestyle Challenge (L'esibizione)</h4>
        <p className="text-gray-300 mb-4 leading-relaxed">
          La prima parte del format porta gli ospiti direttamente al microfono, ma allontanandosi dalle classiche dinamiche da battle da palco. Rend testa le abilità di improvvisazione dei freestyler attraverso giochi e sfide tematiche:
        </p>
        <ul className="text-gray-300 space-y-3 list-disc list-inside mb-4">
          <li className="leading-relaxed">
            <strong className="text-white">La Challenge dell'ospite precedente:</strong> gli MC ricevono un video-messaggio da un altro freestyler (spesso un amico o un collega passato precedentemente nel programma) che assegna loro una tematica assurda. In una puntata, ad esempio, agli ospiti viene chiesto di impersonare i protagonisti delle vecchie pubblicità degli anni '90.
          </li>
          <li className="leading-relaxed">
            <strong className="text-white">La sfida dei "Pizzini":</strong> per alzare il livello di difficoltà, Rend introduce l'estrazione di bigliettini a sorpresa. I rapper si sfidano in un classico 1 contro 1 a colpi di 4 o 8 quarti, ma devono obbligatoriamente calarsi nei panni dei personaggi estratti (da Lino Banfi a Maccio Capatonda, fino a Gerry Scotti), testando la loro capacità di storytelling istantaneo e comicità.
          </li>
        </ul>

        <h4 className="text-xl font-bold mt-6 mb-3 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>2. Il Talk / Intervista (Dietro le quinte)</h4>
        <p className="text-gray-300 mb-4 leading-relaxed">
          Dopo aver fatto scaldare le rime, il format si trasforma in un'intervista informale in cui Rend si siede a chiacchierare con gli artisti, andando oltre il semplice freestyle per esplorare la loro carriera:
        </p>
        <ul className="text-gray-300 space-y-3 list-disc list-inside mb-4">
          <li className="leading-relaxed">
            <strong className="text-white">Il circuito delle Battle:</strong> Rend indaga sui ritmi del circuito, chiedendo ad esempio quante competizioni affrontano in media (scoprendo che alcuni arrivano a partecipare a 30-40 battle all'anno, viaggiando costantemente in tutta Italia).
          </li>
          <li className="leading-relaxed">
            <strong className="text-white">I Progetti Discografici:</strong> il format funge anche da vetrina per la musica scritta. Viene dato spazio agli artisti per promuovere i loro futuri dischi ufficiali, EP o singoli in uscita, dimostrando che la creatività non si ferma all'improvvisazione.
          </li>
          <li className="leading-relaxed">
            <strong className="text-white">Aneddoti e Storicità:</strong> vengono ripercorsi i precedenti scontri diretti tra gli MC presenti, ricordando insieme ai fan quante finali hanno disputato uno contro l'altro, qual è stata la sfida più bella e quali sono stati i contesti più pittoreschi in cui si sono affrontati in passato.
          </li>
        </ul>

        <p className="text-gray-300 mb-8 leading-relaxed italic border-l-4 border-red-400 pl-4 py-2" style={{ backgroundColor: 'rgba(220,38,38,0.08)' }}>
          In sintesi, <strong className="text-white">Freestyle Reaction</strong> è un format dinamico che permette ai fan di vedere i freestyler fuori dalla tensione agonistica dei grandi palchi, facendoli divertire con challenge tecniche e, allo stesso tempo, approfondendo il lato umano, lavorativo e discografico di chi vive questa disciplina tutti i giorni.
        </p>

        {/* Stagione 1 */}
        <h4 className="text-2xl font-bold mt-8 mb-4 text-red-400 text-center" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          STAGIONE 1
        </h4>
        <div className="rounded-lg overflow-hidden border border-gray-700 mb-6" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.youtube.com/embed/dsCpm_t_DMk?list=PLw3BVEFbgSg6ZBauUtMNgWmTDjonUyRbd"
              title="Freestyle Reaction - Stagione 1"
              data-testid="freestyle-reaction-s1"
              className="absolute top-0 left-0 w-full h-full"
              style={{ border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>

        {/* Stagione 2 */}
        <h4 className="text-2xl font-bold mt-8 mb-4 text-red-400 text-center" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          STAGIONE 2
        </h4>
        <div className="rounded-lg overflow-hidden border border-gray-700" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.youtube.com/embed/QAGBIPqLyV0?list=PLUTXL6aCnxEAMOstHpNJmH9aS-xBwg4Gu"
              title="Freestyle Reaction - Stagione 2"
              data-testid="freestyle-reaction-s2"
              className="absolute top-0 left-0 w-full h-full"
              style={{ border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
      </>
    )
  },
  {
    id: 6,
    order: 10,
    title: "MICROPHONE MASTA",
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/ot2iczsz_logo%20microphone%20masta.avif",
    teaserVideoId: "lQGCSzs1XEY",
    icon: Music,
    shortDesc: "GLI MC's e i BEATBOXER in squadra in un clash 2 VS 2 senza esclusioni di skillz",
    fullContent: (
      <>
        <h3 className="text-2xl font-bold mb-4 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>MICROPHONE MASTA</h3>
        <p className="text-gray-300 mb-4 leading-relaxed">
          Lunghe sessioni di freestyle dove tecnica e contenuto fanno la differenza.
        </p>
        <p className="text-gray-300 mb-6 leading-relaxed">
          Solo per veri maestri del microfono. La qualità delle rime e la padronanza del flow vengono giudicate al massimo livello.
        </p>

        {/* Sezione DHAP & ItaBeatboxers */}
        <div className="rounded-lg border border-red-600/30 bg-red-900/10 p-4 sm:p-5 mb-6">
          <h4 className="text-xl sm:text-2xl font-bold mb-1 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>
            DHAP
          </h4>
          <p className="text-[11px] uppercase tracking-widest text-gray-500 mb-4" style={{ fontFamily: 'Oswald, sans-serif' }}>
            Co-ideatore del Microphone Masta · ItaBeatboxers
          </p>

          {/* Foto + bio in 2 colonne */}
          <div className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-4 mb-4">
            <div className="flex justify-center md:justify-start">
              <img
                src="https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/9i1r9n0y_448924478_10159727147376965_4880910668063542195_n.jpg"
                alt="Dhap live performance"
                data-testid="dhap-photo"
                className="w-40 h-40 sm:w-44 sm:h-44 object-cover rounded-lg border-2 border-red-600/40 shadow-lg"
              />
            </div>
            <div className="space-y-3">
              <p className="text-gray-300 leading-relaxed text-sm">
                <strong className="text-white">Dhap</strong>, di origini calabresi e residente a Parma, è uno dei pionieri
                dell'<strong className="text-white">Human Beatbox</strong> in Italia. Già attivo nella scena Rap e Freestyle
                nazionale, nel <strong className="text-red-400">2006</strong> fonda il progetto{' '}
                <strong className="text-white">ItaBeatboxers</strong>, dando il via a ciò che diventerà il movimento beatbox
                italiano organizzato. Ha collaborato a lungo con artisti come <em className="text-gray-200">Nema</em>, il rapper{' '}
                <em className="text-gray-200">Fabio Dank</em> e il <em className="text-gray-200">Dj T-Robb</em>.
              </p>

              <p className="text-gray-300 leading-relaxed text-sm">
                Dopo la partecipazione alla <strong className="text-white">Beatbox Battle World</strong> di Berlino del 2008,
                Dhap organizza il <strong className="text-white">primo raduno italiano di beatboxer</strong> al Mu di Parma
                (22 novembre 2008), con ospiti internazionali del calibro di <em className="text-gray-200">Roxorloops</em>{' '}
                (vice-campione mondiale 2008) e <em className="text-gray-200">Alien Dee</em>. L'evento ricevette anche la
                copertura della <strong className="text-white">Rai 2</strong> nel programma <em>TG2 — Costume e Società</em>.
              </p>
            </div>
          </div>

          <p className="text-gray-300 leading-relaxed text-sm mb-3">
            I <strong className="text-white">campionati nazionali ItaBeatboxers</strong> hanno costruito la storia della
            disciplina in Italia: <em className="text-gray-200">BeeCee</em> primo campione italiano (Reggio Emilia 2009),
            poi <em className="text-gray-200">Orange Beat</em> a Bologna 2011, <em className="text-gray-200">Mex Zee</em>{' '}
            a Varese 2013, di nuovo <em className="text-gray-200">BeeCee</em> nel 2014 e <em className="text-gray-200">Orange Beat</em>{' '}
            nel 2015. Le prime campionesse italiane femminili furono{' '}
            <em className="text-gray-200">Winka</em> e <em className="text-gray-200">Lady Wake</em> (2011 e 2013).
          </p>

          <h5 className="text-base font-bold text-red-400 mt-4 mb-2" style={{ fontFamily: 'Oswald, sans-serif' }}>
            Il legame con Tecniche Perfette: il Microphone Masta
          </h5>
          <p className="text-gray-300 leading-relaxed text-sm mb-3">
            ItaBeatboxers ha co-organizzato il <strong className="text-white">Microphone Masta</strong> insieme a{' '}
            <strong className="text-white">Mastafive</strong> e <strong className="text-red-400">Tecniche Perfette</strong>:
            un contest 2 vs 2 in cui un MC e un beatboxer formavano un'unica squadra. Tre edizioni a partire dal{' '}
            <strong className="text-white">2010</strong>:
          </p>
          <ul className="text-gray-300 text-sm leading-relaxed list-disc list-inside space-y-1 mb-4 pl-2">
            <li><strong className="text-white">2012 — Torino, Hiroshima Mon Amour:</strong> vincono{' '}
              <em className="text-gray-200">Mex Zee &amp; WhiskyMan</em>, finalisti <em className="text-gray-200">Jak &amp; King Om</em>.</li>
            <li><strong className="text-white">2015 — Officine Ferroviarie, Torino:</strong> tappa nord vinta da{' '}
              <em className="text-gray-200">SkyL &amp; Snoopy</em> contro <em className="text-gray-200">Syntex &amp; Virux</em>;
              l'edizione si interruppe prima delle eliminatorie centro/sud.</li>
            <li><strong className="text-red-400">2024 — III Edizione:</strong> trionfo del duo{' '}
              <strong className="text-white">NTUFN &amp; VEZEVE</strong>, che si sono aggiudicati l'accesso diretto alla
              finalissima nazionale di quella stessa edizione del <strong className="text-white">Tecniche Perfette</strong>.</li>
          </ul>

          <p className="text-[11px] text-gray-500 italic border-t border-gray-700 pt-3">
            Fonti storiche:{' '}
            <a
              href="https://www.beatboxfamily.it/human-beatbox-in-italia/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-400 hover:text-red-300 underline"
            >
              ItaBeatboxers / Beatbox Family
            </a>
            {' '}— archivio storico dello Human Beatbox in Italia.
          </p>
        </div>

        {/* Video embeds Microphone Masta */}
        <h4 className="text-xl font-bold mb-4 text-red-400 text-center" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          GUARDA I VIDEO
        </h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {[
            { n: 1, id: 'lQGCSzs1XEY' },
            { n: 2, id: 'tlRFY2iKFG0' },
            { n: 3, id: 'VSgxL244YRo' },
            { n: 4, id: 'Jdy_VfUWZW4' },
          ].map((v) => (
            <div key={v.n} className="rounded-lg overflow-hidden border border-gray-700" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
              <div className="px-3 py-2 border-b border-gray-700">
                <h5 className="text-xs font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>
                  EPISODIO {v.n}
                </h5>
              </div>
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  src={`https://www.youtube.com/embed/${v.id}`}
                  title={`Microphone Masta - Episodio ${v.n}`}
                  data-testid={`microphone-masta-video-${v.n}`}
                  className="absolute top-0 left-0 w-full h-full"
                  style={{ border: 0 }}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
            </div>
          ))}
        </div>
      </>
    ),
    hasForm: true,
    formType: 'microphone-masta'
  },
  {
    id: 8,
    order: 4,
    title: "MTV SPIT",
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/omwekie4_YOCLAS-MTV-SPIT-rap-show-brand-logo.jpg",
    teaserVideoId: "oowhEeOXXIg",
    icon: Mic,
    shortDesc: "Il talent di rap e freestyle che ha segnato la storia della TV italiana",
    fullContent: (
      <>
        <h3 className="text-2xl font-bold mb-4 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>MTV SPIT</h3>
        <p className="text-gray-300 mb-4 leading-relaxed">
          <strong className="text-white">MTV Spit</strong> è stato il talent show italiano dedicato al rap e al freestyle andato in onda su MTV, che ha portato per la prima volta le battle di freestyle sul grande schermo televisivo nazionale.
        </p>
        <p className="text-gray-300 mb-6 leading-relaxed">
          Uno dei programmi più importanti per la cultura Hip Hop italiana, dove tanti artisti legati al mondo di Tecniche Perfette hanno avuto modo di farsi conoscere dal grande pubblico.
        </p>

        {/* Playlist YouTube embed */}
        <h4 className="text-xl font-bold mb-4 text-red-400 text-center" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          GUARDA LA PLAYLIST
        </h4>
        <div className="rounded-lg overflow-hidden border border-gray-700" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.youtube.com/embed/oowhEeOXXIg?list=PLZYSw95w2vYgv_u0SoJd9DprKPdSlsx1j"
              title="MTV Spit - Playlist"
              data-testid="mtvspit-playlist"
              className="absolute top-0 left-0 w-full h-full"
              style={{ border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
      </>
    )
  },
  {
    id: 9,
    order: 8,
    title: "2 REAL",
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/18wni9yu_2real.gif",
    teaserVideoId: "364rhOLHjDM",
    icon: Trophy,
    shortDesc: "La Freestyle Battle del Bundalinda — Solo i migliori, only the realest",
    fullContent: (
      <>
        <h3 className="text-2xl font-bold mb-4 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>2 REAL FREESTYLE BATTLE</h3>

        <p className="text-gray-300 mb-4 leading-relaxed">
          La <strong className="text-white">2REAL Freestyle Battle</strong> è una competizione di improvvisazione rap che si svolge presso il <strong className="text-white">Bundalinda</strong> (storico locale e pub di Brugherio, in provincia di Monza e Brianza). L'evento è organizzato in stretta collaborazione con il collettivo lombardo <strong className="text-white">Vikings Klan</strong> ed è coperto mediaticamente da <strong className="text-white">We Got Flava</strong>.
        </p>

        <p className="text-gray-300 mb-4 leading-relaxed">
          Ecco i dettagli principali che caratterizzano la battle:
        </p>

        <h4 className="text-lg font-bold mt-5 mb-2 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>Lo Scopo:</h4>
        <p className="text-gray-300 mb-4 leading-relaxed">
          Nasce con un duplice obiettivo: fungere da vera e propria <strong className="text-white">"palestra"</strong> per allenare le nuove leve della scena rap lombarda e, allo stesso tempo, scovare e premiare i migliori improvvisatori del panorama.
        </p>

        <h4 className="text-lg font-bold mt-5 mb-2 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>Il Format e le Modalità:</h4>
        <p className="text-gray-300 mb-4 leading-relaxed">
          La battle presenta un tabellone inedito e si distingue per le sue sfide altamente coinvolgenti. Si parte solitamente con turni a <strong className="text-white">Cypher</strong> (cerchi in cui più MC si scontrano contemporaneamente in barre da 4/4 per guadagnarsi la semifinale) fino ad arrivare alle finali. La modalità speciale <strong className="text-red-400">"2REAL"</strong> per la finalissima prevede spesso un <strong className="text-white">"giro della morte"</strong> in 4/4 ad argomento, in cui le parole o i temi cambiano ogni 3 entrate per testare la reale capacità di improvvisazione al 100%.
        </p>

        <h4 className="text-lg font-bold mt-5 mb-2 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>Premi e Giuria:</h4>
        <p className="text-gray-300 mb-4 leading-relaxed">
          È prevista sempre una giuria di esperti del settore (che ha visto alternarsi nomi come <strong className="text-white">Efsi9, Roger, Sal Draven e Snake</strong>) e un premio garantito per i primi tre classificati.
        </p>

        <h4 className="text-lg font-bold mt-5 mb-2 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>La Location:</h4>
        <p className="text-gray-300 mb-6 leading-relaxed">
          Il palco del <strong className="text-white">Bundalinda</strong> è considerato uno spazio storico. Da anni, infatti, il locale (grazie al proprietario <strong className="text-white">Davide</strong>) mette a disposizione il proprio palcoscenico per supportare attivamente il freestyle e la cultura Hip Hop italiana.
        </p>

        <blockquote className="border-l-4 border-red-600 pl-4 my-6 italic text-white text-lg" style={{ fontFamily: 'Oswald, sans-serif' }}>
          "Solo i migliori, only the realest."
          <footer className="text-gray-400 text-xs not-italic mt-1">— Motto ufficiale 2 REAL</footer>
        </blockquote>

        {/* Roll-over sito ufficiale 2REAL */}
        <h4 className="text-xl font-bold mt-8 mb-4 text-red-400 text-center" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          VISITA IL SITO UFFICIALE
        </h4>
        <div className="rounded-lg overflow-hidden border border-gray-700 mb-6" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
          <div className="relative w-full" style={{ paddingBottom: '66%' }}>
            <iframe
              src="https://2realfreestylebattlemilano.my.canva.site/"
              title="2 REAL Freestyle Battle - Sito ufficiale"
              data-testid="tworeal-site-iframe"
              className="absolute top-0 left-0 w-full h-full"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </div>
          <div className="px-4 py-2 border-t border-gray-700 text-center">
            <a
              href="https://2realfreestylebattlemilano.my.canva.site/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="tworeal-site-link"
              className="inline-flex items-center gap-2 text-red-400 hover:text-red-300 text-xs font-bold"
              style={{ fontFamily: 'Oswald, sans-serif' }}
            >
              APRI IL SITO IN UNA NUOVA SCHEDA →
            </a>
          </div>
        </div>

        {/* Playlist YouTube 2REAL */}
        <h4 className="text-xl font-bold mt-8 mb-4 text-red-400 text-center" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          GUARDA LA PLAYLIST
        </h4>
        <div className="rounded-lg overflow-hidden border border-gray-700" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.youtube.com/embed/364rhOLHjDM?list=PLw3BVEFbgSg6zSY-wkvfMtRZ3kspapPob"
              title="2 REAL Freestyle Battle - Playlist"
              data-testid="tworeal-playlist"
              className="absolute top-0 left-0 w-full h-full"
              style={{ border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
      </>
    )
  },

  {
    id: 7,
    order: 3,
    title: "FREESTYLEMANIA 3vs3",
    image: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/xkjh9ub0_freestylemania.webp",
    teaserVideoId: "2ktNOZOHb6g",
    icon: Users,
    shortDesc: "La prima battle a team 3v3 in Italia - Nata da Rend & Mastafive nel 2018",
    fullContent: (
      <>
        <h3 className="text-2xl font-bold mb-4 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>FREESTYLEMANIA 3vs3 BATTLE</h3>

        <p className="text-gray-300 mb-4 leading-relaxed">
          <strong className="text-white">FreestyleMania</strong> nasce da un'idea di <strong className="text-white">Rend</strong> nel 2018 assieme a <strong className="text-white">Mastafive</strong> (Tecniche Perfette)! L'obiettivo è quello di creare una <strong className="text-red-400">battle a team 3v3</strong>. La prima in Italia.
        </p>
        <p className="text-gray-300 mb-6 leading-relaxed">
          I 4 capitani selezionati (da Rend e Mastafive) hanno scelto a loro volta i componenti per i propri team.
        </p>

        {/* Team 1 - NERA */}
        <div className="mb-5 p-4 rounded-lg border-l-4 border-gray-400" style={{ backgroundColor: 'rgba(255,255,255,0.04)' }}>
          <h4 className="text-lg font-bold mb-2" style={{ fontFamily: 'Oswald, sans-serif', color: '#e5e5e5' }}>
            WACK SLAYERS — Divisa Nera <span className="text-gray-400 font-normal">(Capitano: Morbo)</span>
          </h4>
          <ul className="space-y-2 text-gray-300 text-sm leading-relaxed list-disc list-inside">
            <li><strong className="text-white">MORBO</strong> — Vincitore Tecniche Perfette 2015, Vincitore Mic Tyson Vol.1, testa di serie Tritolo Vol.1-2</li>
            <li><strong className="text-white">REIVEN</strong> — Vincitore T.P. 2016, testa di serie Mic Tyson Vol.1 & Vol.3</li>
            <li><strong className="text-white">HYDRA</strong> — Finalista T.P. 2019, Vincitore imbattuto Mic Scrauso I e II edizione, testa di serie Tritolo 2019, qualificato Mic Tyson Vol.3</li>
          </ul>
        </div>

        {/* Team 2 - GIALLA */}
        <div className="mb-5 p-4 rounded-lg border-l-4 border-yellow-400" style={{ backgroundColor: 'rgba(250,204,21,0.08)' }}>
          <h4 className="text-lg font-bold mb-2" style={{ fontFamily: 'Oswald, sans-serif', color: '#fde047' }}>
            IL BRUNO, IL TULLO E IL TRENTINO — Divisa Gialla <span className="text-gray-400 font-normal">(Capitano: Drimer)</span>
          </h4>
          <ul className="space-y-2 text-gray-300 text-sm leading-relaxed list-disc list-inside">
            <li><strong className="text-white">DRIMER</strong> — Vincitore Tritolo 2018, qualificazione T.P. 2018-2019, qualificazione Mic Tyson Vol.1 & Vol.3</li>
            <li><strong className="text-white">BRUNO BUG</strong> — Qualificazione Mic Tyson Vol.3, qualificazione finale T.P. 2018-2019</li>
            <li><strong className="text-white">TULLO</strong> — Finalista T.P. 2018-2019, testa di serie Tritolo 2019, qualificato Mic Tyson Vol.1, Vol.2 & Vol.3</li>
          </ul>
        </div>

        {/* Team 3 - VERDE */}
        <div className="mb-5 p-4 rounded-lg border-l-4 border-green-500" style={{ backgroundColor: 'rgba(34,197,94,0.08)' }}>
          <h4 className="text-lg font-bold mb-2" style={{ fontFamily: 'Oswald, sans-serif', color: '#4ade80' }}>
            I THREEVIALI — Divisa Verde <span className="text-gray-400 font-normal">(Capitano: Blnkay)</span>
          </h4>
          <ul className="space-y-2 text-gray-300 text-sm leading-relaxed list-disc list-inside">
            <li><strong className="text-white">BLNKAY</strong> — Campione T.P. 2018, Campione Mic Tyson Vol.3, testa di serie Tritolo 2019</li>
            <li><strong className="text-white">SHAME</strong> — Qualificato T.P. 2018-2019, qualificato Mic Tyson Vol.2 & Vol.3</li>
            <li><strong className="text-white">ARCYDEMON</strong> — Vincitore Alleyoop 2018</li>
          </ul>
        </div>

        {/* Team 4 - ROSA */}
        <div className="mb-5 p-4 rounded-lg border-l-4 border-pink-400" style={{ backgroundColor: 'rgba(244,114,182,0.08)' }}>
          <h4 className="text-lg font-bold mb-2" style={{ fontFamily: 'Oswald, sans-serif', color: '#f472b6' }}>
            4UATTRO/4UARTI DREAM TEAM — Divisa Rosa <span className="text-gray-400 font-normal">(Capitano: Shekkero)</span>
          </h4>
          <ul className="space-y-2 text-gray-300 text-sm leading-relaxed list-disc list-inside">
            <li><strong className="text-white">SHEKKERO</strong> — Vincitore T.P. 2017, Vincitore Mic Tyson Vol.2, Vincitore Tritolo 2019. Unico freestyler italiano ad aver completato il triplete</li>
            <li><strong className="text-white">FRENK</strong> — Vincitore T.P. 2019, testa di serie Mic Tyson Vol.3, testa di serie Tritolo Vol.1 & Vol.2</li>
            <li><strong className="text-white">VOLPEROSSA</strong> — Qualificato T.P. 2019, qualificato Tritolo Vol.1</li>
          </ul>
        </div>

        {/* Staff */}
        <div className="mt-6 p-4 rounded-lg border border-gray-700" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <h4 className="text-base font-bold mb-3 text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>STAFF & CONDUZIONE</h4>
          <p className="text-gray-300 text-sm mb-2 leading-relaxed">
            <strong className="text-white">Valutazione:</strong> Nerone (campione MTV Spit) e Kenzie Kenzei (campione T.P. 2010)
          </p>
          <p className="text-gray-300 text-sm mb-2 leading-relaxed">
            <strong className="text-white">Conduzione:</strong> Mastafive, Rend e Comagatte
          </p>
          <p className="text-gray-300 text-sm leading-relaxed">
            <strong className="text-white">Divanetto Reaction (schermo in basso):</strong> Dr. Jack e Poomba
          </p>
        </div>

        {/* Video embeds + mini player reaction */}
        <FreestyleManiaVideos />
      </>
    )
  }
];

// Card singola: supporta teaser video hover (Netflix-style) per format con teaserVideoId
const FormatCard = ({ format, renderFormContent }) => {
  const [isHovering, setIsHovering] = useState(false);
  const teaserId = format.teaserVideoId;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <div
          className="rounded-lg overflow-hidden border border-gray-800 hover:border-red-600 transition-all duration-300 cursor-pointer group"
          style={{ backgroundColor: 'var(--tp-dark)' }}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          data-testid={`format-card-${format.id}`}
        >
          <div className="h-40 sm:h-48 relative overflow-hidden">
            <img
              src={format.image}
              alt={format.title}
              className={`w-full h-full ${format.id === 2 || format.id === 3 ? 'object-contain' : 'object-cover'} group-hover:scale-105 transition-transform duration-500`}
            />
            {/* Teaser video hover (Netflix-style) */}
            {teaserId && isHovering && (
              <iframe
                src={`https://www.youtube.com/embed/${teaserId}?autoplay=1&mute=1&loop=1&controls=0&modestbranding=1&rel=0&playsinline=1&playlist=${teaserId}&start=8`}
                title={`${format.title} - preview`}
                data-testid={`format-card-teaser-${format.id}`}
                className="absolute inset-0 w-full h-full pointer-events-none"
                style={{ border: 0, objectFit: 'cover' }}
                allow="autoplay; encrypted-media"
                referrerPolicy="strict-origin-when-cross-origin"
                aria-hidden="true"
                tabIndex={-1}
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent pointer-events-none" />
            <h3 className="absolute bottom-3 left-3 right-3 text-base sm:text-lg font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>
              {format.title}
            </h3>
          </div>
          <div className="p-3 sm:p-4">
            <p className="text-gray-400 text-xs sm:text-sm">{format.shortDesc}</p>
          </div>
        </div>
      </DialogTrigger>
      <DialogContent className="bg-gray-900 border-gray-700 max-w-[95vw] sm:max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogTitle className="sr-only">{format.title}</DialogTitle>
        <DialogDescription className="sr-only">{format.shortDesc}</DialogDescription>
        <div className="space-y-4">
          <div className="relative h-48 sm:h-56 rounded-lg overflow-hidden">
            <img
              src={format.image}
              alt={format.title}
              className={`w-full h-full ${format.id === 2 || format.id === 3 ? 'object-contain' : 'object-cover'}`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <h2 className="text-3xl sm:text-4xl font-bold text-white" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
                {format.title}
              </h2>
              <p className="text-gray-300 text-sm mt-1">{format.shortDesc}</p>
            </div>
          </div>

          <div className="px-2 space-y-2 text-sm sm:text-base">
            {renderFormContent(format)}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const AltriFormatPage = () => {
  const [cyphaFormData, setCyphaFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: ''
  });
  const [cashFormData, setCashFormData] = useState({
    email: ''
  });
  const [mcFormData, setMcFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [microphonemFormData, setMicrophonemFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [currentForm, setCurrentForm] = useState('');

  const handleCyphaSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage('');
    setCurrentForm('cypha');

    try {
      await submitCyphaKingsRegistration(cyphaFormData);
      setMessage('✅ Iscrizione Cypha Kings inviata con successo!');
      setCyphaFormData({ name: '', email: '', phone: '', city: '' });
    } catch (error) {
      setMessage('❌ Errore nell\'invio. Riprova.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCashSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage('');
    setCurrentForm('cash');

    try {
      await submitFuoriCashNewsletter(cashFormData);
      setMessage('✅ Iscrizione newsletter inviata con successo!');
      setCashFormData({ email: '' });
    } catch (error) {
      setMessage('❌ Errore nell\'invio. Riprova.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCyphaChange = (e) => {
    setCyphaFormData({
      ...cyphaFormData,
      [e.target.name]: e.target.value
    });
  };

  const handleCashChange = (e) => {
    setCashFormData({
      ...cashFormData,
      [e.target.name]: e.target.value
    });
  };

  const renderFormContent = (format) => {
    if (format.formType === 'cypha-kings') {
      return (
        <>
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-3" style={{ fontFamily: 'Oswald, sans-serif' }}>PERCHÉ "KINGS DEL CERCHIO"?</h3>
          <p className="text-gray-300 mb-3 leading-relaxed">
            Sei un king se prendi il microfono e sputi le tue rime nel cerchio, perché significa che hai scelto il confronto e la condivisione che portano alla crescita.
          </p>
          <p className="text-gray-300 mb-3 leading-relaxed">
            Non è una sfida, perché CK non è una battle e nemmeno un contest: è una grande Jam Session di improvvisazione lirica rap. Nessuna nuova idea rivoluzionaria, dal giorno 1 nel cerchio ci si mette in gioco. Esci dalla tua bolla per farti conoscere dagli altri, ma soprattutto per conoscere gli altri e condividere esperienze e skills. Improvvisando o sputando le tue barre – crude, divertenti, romantiche o introverse – non importa la tua ispirazione, perché è il tuo spirito che si esprime. Con il nostro linguaggio: quello del rap.
          </p>
          <p className="text-gray-300 mb-3 leading-relaxed">
            Il tutto in una grande festa dove il DJ alterna la musica a un set di basi infinito, dove l'unico limite è la fantasia... tutto questo è il vero spirito Hip Hop.
          </p>
          <p className="text-gray-300 mb-3 leading-relaxed">
            Nessuno entra nel cerchio per giudicare, ma solo per condividere. Non esistono carriera, stato sociale, religione o etnia... ci sei solo tu con gli altri e la musica.
          </p>
          <p className="text-gray-300 mb-6 leading-relaxed">
            Sei pronto a sentirti Re del cerchio, Re del microfono? Ti aspettiamo... sarai un king semplicemente perché ci sei. I poser lasciamoli a casa davanti allo schermo.
          </p>

          <div className="mt-6 p-4 sm:p-6 rounded-lg border border-gray-700" style={{ backgroundColor: 'var(--tp-dark)' }}>
            <h4 className="text-lg sm:text-xl font-bold text-white mb-4" style={{ fontFamily: 'Oswald, sans-serif' }}>ISCRIVITI AL CYPHA KINGS</h4>
            <form onSubmit={handleCyphaSubmit} className="space-y-4">
              <div>
                <input
                  type="text"
                  name="name"
                  value={cyphaFormData.name}
                  onChange={handleCyphaChange}
                  placeholder="Nome Completo *"
                  required
                  className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:border-red-500 focus:outline-none"
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  value={cyphaFormData.email}
                  onChange={handleCyphaChange}
                  placeholder="Email *"
                  required
                  className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:border-red-500 focus:outline-none"
                />
              </div>
              <div>
                <input
                  type="tel"
                  name="phone"
                  value={cyphaFormData.phone}
                  onChange={handleCyphaChange}
                  placeholder="Telefono *"
                  required
                  className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:border-red-500 focus:outline-none"
                />
              </div>
              <div>
                <input
                  type="text"
                  name="city"
                  value={cyphaFormData.city}
                  onChange={handleCyphaChange}
                  placeholder="Città *"
                  required
                  className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:border-red-500 focus:outline-none"
                />
              </div>
              <button
                type="submit"
                disabled={submitting && currentForm === 'cypha'}
                className="w-full px-6 py-3 rounded text-white font-bold transition-opacity hover:opacity-90 disabled:opacity-50"
                style={{ backgroundColor: 'var(--tp-red)', fontFamily: 'Oswald, sans-serif' }}
              >
                {submitting && currentForm === 'cypha' ? 'INVIO IN CORSO...' : 'ISCRIVITI ORA'}
              </button>
            </form>
            {message && currentForm === 'cypha' && (
              <p className={`mt-4 text-center text-sm ${message.includes('✅') ? 'text-green-400' : 'text-red-400'}`}>
                {message}
              </p>
            )}
          </div>

          {/* Playlist YouTube Cypha Kings */}
          <h4 className="text-xl font-bold mt-8 mb-4 text-red-400 text-center" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
            GUARDA LA PLAYLIST
          </h4>
          <div className="rounded-lg overflow-hidden border border-gray-700" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <iframe
                src="https://www.youtube.com/embed/aqtHKX5CwzA?list=PLw3BVEFbgSg67Uyp9aqbUcQi6XbZab73c"
                title="Cypha Kings - Playlist"
                data-testid="cypha-kings-playlist"
                className="absolute top-0 left-0 w-full h-full"
                style={{ border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </div>
        </>
      );
    }

    if (format.formType === 'fuori-cash') {
      return (
        <>
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Oswald, sans-serif' }}>FUORI PER IL CASH</h3>
          <p className="text-gray-300 mb-3 leading-relaxed">
            Fuori per il cash è la battle di Freestyle che non prevede un torneo, nemmeno un vincitore nazionale, è fine a se stessa.
          </p>
          <p className="text-gray-300 mb-3 leading-relaxed">
            Il nome prende ispirazione dal pezzo dei <strong className="text-white">CDB</strong> "FUORI PER IL CASH".
          </p>
          <p className="text-gray-300 mb-3 leading-relaxed">
            Serve prima di tutto a <strong className="text-white">tenere in allenamento i freestyler</strong> e dare la possibilità di confrontarsi ai nuovi, senza la pressione di una battle "grossa". Funziona ad iscrizione di <strong className="text-red-400">5€</strong>, i soldi degli iscritti saranno il premio del vincitore.
          </p>
          <p className="text-gray-300 mb-3 leading-relaxed">
            Non ci sono regole particolari, non ci sono metodi di valutazione.
          </p>
          <p className="text-gray-300 mb-3 leading-relaxed">
            C'è il pubblico (quando troppo di parte decide il 'Maestro di Cerimonia'). Ci possono essere argomenti, ci possono essere temi... oppure tutto libero.
          </p>
          <p className="text-gray-300 mb-3 leading-relaxed">
            Per info e contatti la mail è la stessa del sito del T.P.
          </p>
          <p className="text-gray-300 mb-4 leading-relaxed">
            Cosa aspettate allora, <strong className="text-white">allenatevi e venite "fuori per il cash"!!</strong>
          </p>
          <p className="text-gray-300 mb-2 leading-relaxed">
            <strong className="text-white">Ai piatti:</strong> Mastafive
          </p>
          <p className="text-gray-300 mb-6 leading-relaxed text-sm">
            Se volete organizzare "Fuori per il cash" nel vostro locale contattate <a href="mailto:book@masnetwork.it" className="text-red-400 hover:underline">book@masnetwork.it</a>
          </p>

          {/* Playlist Fuori per il Cash */}
          <div className="mb-6 rounded-lg overflow-hidden border border-gray-700" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
            <div className="px-4 py-3 border-b border-gray-700">
              <h5 className="text-base font-bold text-red-400" style={{ fontFamily: 'Oswald, sans-serif' }}>
                GUARDA LA PLAYLIST
              </h5>
            </div>
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <iframe
                src="https://www.youtube.com/embed/paZDDqd8Qx8?list=PLw3BVEFbgSg75EzTC4mICfTtJcxO-xkAm"
                title="Fuori per il Cash - Playlist"
                data-testid="fuori-cash-video"
                className="absolute top-0 left-0 w-full h-full"
                style={{ border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </div>

          <div className="p-4 sm:p-6 rounded-lg border-2 border-red-600" style={{ backgroundColor: 'var(--tp-dark)' }}>
            <h4 className="text-lg sm:text-xl font-bold text-white mb-2 text-center" style={{ fontFamily: 'Oswald, sans-serif' }}>ISCRIVITI ALLA NEWSLETTER PER LE DATE</h4>
            <p className="text-gray-400 text-xs text-center mb-4">CI SI ISCRIVE LA SERA STESSA - COSTO ISCRIZIONE 5€</p>
            <form onSubmit={handleCashSubmit} className="space-y-4">
              <div>
                <input
                  type="email"
                  name="email"
                  value={cashFormData.email}
                  onChange={handleCashChange}
                  placeholder="La tua email *"
                  required
                  className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:border-red-500 focus:outline-none"
                />
              </div>
              <button
                type="submit"
                disabled={submitting && currentForm === 'cash'}
                className="w-full px-6 py-3 rounded text-white font-bold transition-opacity hover:opacity-90 disabled:opacity-50"
                style={{ backgroundColor: 'var(--tp-red)', fontFamily: 'Oswald, sans-serif' }}
              >
                {submitting && currentForm === 'cash' ? 'INVIO IN CORSO...' : 'ISCRIVITI ALLA NEWSLETTER'}
              </button>
            </form>
            {message && currentForm === 'cash' && (
              <p className={`mt-4 text-center text-sm ${message.includes('✅') ? 'text-green-400' : 'text-red-400'}`}>
                {message}
              </p>
            )}
          </div>
        </>
      );
    }

    return format.fullContent;
  };

  const handleMcSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage('');
    setCurrentForm('3mc');

    try {
      // Usa lo stesso endpoint contatti per ora
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'}/api/contacts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: mcFormData.name,
          email: mcFormData.email,
          subject: '3 MC\'s & 1 DJ - Richiesta Info',
          message: `Telefono: ${mcFormData.phone}\n\nMessaggio: ${mcFormData.message}`,
          privacy_accepted: true
        })
      });
      
      if (response.ok) {
        setMessage('✅ Richiesta inviata con successo!');
        setMcFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        throw new Error('Errore invio');
      }
    } catch (error) {
      setMessage('❌ Errore nell\'invio. Riprova.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleMicrophonemSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage('');
    setCurrentForm('microphone');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'}/api/contacts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: microphonemFormData.name,
          email: microphonemFormData.email,
          subject: 'Microphone Masta - Richiesta Info',
          message: `Telefono: ${microphonemFormData.phone}\n\nMessaggio: ${microphonemFormData.message}`,
          privacy_accepted: true
        })
      });
      
      if (response.ok) {
        setMessage('✅ Richiesta inviata con successo!');
        setMicrophonemFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        throw new Error('Errore invio');
      }
    } catch (error) {
      setMessage('❌ Errore nell\'invio. Riprova.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="py-10 sm:py-16 px-4" style={{ backgroundColor: 'var(--tp-black)', minHeight: '80vh' }}>
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-2 text-white"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          ALTRI FORMAT
        </h1>
        <div className="w-20 h-1 mx-auto mb-4" style={{ backgroundColor: 'var(--tp-red)' }} />
        <p className="text-center text-gray-400 mb-8 sm:mb-12 max-w-xl mx-auto text-sm sm:text-base">
          TECNICHE PERFETTE è anche FORMAT e SHOW EVENTI LIVE
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {[...formats].sort((a, b) => (a.order || 99) - (b.order || 99)).map((format) => (
            <FormatCard key={format.id} format={format} renderFormContent={renderFormContent} />
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center p-10 rounded-lg" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <h3 className="text-3xl font-bold text-white mb-3" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
            VUOI PROPORRE UN NUOVO FORMAT?
          </h3>
          <p className="text-gray-400 mb-6 max-w-md mx-auto">
            Se hai un'idea per un nuovo formato di battle, contattaci! Siamo sempre aperti alle novità.
          </p>
          <a href="/contatti" className="inline-flex items-center gap-2 px-6 py-3 rounded text-white font-bold transition-colors hover:opacity-90"
            style={{ backgroundColor: 'var(--tp-red)', fontFamily: 'Oswald, sans-serif' }}>
            CONTATTACI <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AltriFormatPage;
